import type { ProcessType } from '@frontend/api';

import MaterialSelector from 'modules/common/forms/materialSelector/MaterialSelector';
import ProcessMaterialSelector from 'modules/common/forms/materialSelector/ProcessMaterialSelector';

type MaterialSelectProps = {
  disabled: boolean;
  menuPortalDestinationRef: React.RefObject<HTMLDivElement>;
  onChange: ({
    materialId,
    supplierMaterialId,
  }: {
    materialId: number | null;
    supplierMaterialId: number | null;
  }) => void;
  process?: ProcessType | null;
  selectedMaterialId: number | null;
  selectedSupplierMaterialId: number | null;
};

const MaterialSelect = ({
  disabled,
  menuPortalDestinationRef,
  onChange,
  process,
  selectedMaterialId,
  selectedSupplierMaterialId,
}: MaterialSelectProps) =>
  !process || process.useGlobalMaterials ? (
    <MaterialSelector
      disabled={disabled}
      materialId={selectedMaterialId}
      onChange={onChange}
      placeholder="Select Material"
      supplierMaterialId={selectedSupplierMaterialId}
    />
  ) : (
    <ProcessMaterialSelector
      disabled={disabled}
      menuPortalDestinationRef={menuPortalDestinationRef}
      onChange={onChange}
      process={process}
      placeholder="Select Material"
      selectedMaterialId={selectedMaterialId}
      selectedSupplierMaterialId={selectedSupplierMaterialId}
    />
  );

export default MaterialSelect;
